import { render, staticRenderFns } from "./VBannerActionForm.vue?vue&type=template&id=1b95c72d"
import script from "./VBannerActionForm.vue?vue&type=script&lang=js"
export * from "./VBannerActionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports